import { render, staticRenderFns } from "./access-messenger.vue?vue&type=template&id=3a6d05a9&scoped=true"
import script from "./access-messenger.vue?vue&type=script&lang=js"
export * from "./access-messenger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6d05a9",
  null
  
)

export default component.exports